import PatientSignatureImage from './PatientSignatureImage';
import InitialsField from './InitialsField';

const LALConsent = ({
    pageRefs,
    currentPage,
    logo,
    pageTitles,
    SurgeryFormData,
    surgeonOptionsMap,
    docSignature,
    setSignatures,
    setSurgeryFormData,
    handleInputChange,
    invalidFields,
    isNext,
    isEditing,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    getCentralAmericaDate,
    getCentralAmericaTime,
    Logo,
    Head,
    Paragraph,
    RadioGroup,
    TextInput,
    SignatureField,
    SegLogoBanner,
    Initials,
    surgeryUpload,
    FormInput,
    formattedDate,
    SegFooter

}) => {

    return (
        <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white">
            <SegLogoBanner src={logo} />

            <div className="px-1 mx-8 py-2">
                <Head title="Informed Consent for RXSIGHT's Light Adjustable LensTM" />


                <Paragraph>
                    The RxSight Light Adjustable Lens (RXLALTM) is similar to other intraocular lenses (IOLS) that can be implanted in your eye to replace the natural lens that is removed during cataract surgery. While all IOLs improve vision after cataract surgery, most patients will require glasses (or contact lenses) to improve their vision to the level required for driving or reading. The RXLALT may reduce the need for glasses or contact lenses because the focusing power of the IOL can be adjusted after your cataract surgery to meet your particular needs. These adjustments are made beginning 2-3 weeks after your cataract surgery by applying specific patterns of ultraviolet (UV) light to the IOL to change the shape, which results in changes to the refractive correction of your vision. The UV light is delivered by your doctor with the RxSight Light Delivery Device (LDD). The number of light adjustment treatments you receive will be determined by your doctor. When you and your doctor are satisfied, the same LDD is used to lock in the RXLALTM and make the refraction permanent. From immediately after surgery until 24 hours after the completion of the lock in treatment, you will need to protect the RXLALTM from UV light in the environment by wearing protective eyewear during all waking hours.
                </Paragraph>
                <span className="font-bold">Specific Risks</span>
                <Paragraph>
                    As with other IOLs, if the RXLALTM is scratched or incorrectly placed in the eye at the time of surgery, it may need to be removed with another surgery prior to light treatments.
                </Paragraph>
                <Paragraph>
                    Before the RXLALTM is locked in, you can experience a decrease in vision if you are exposed to daylight or any other UV light source when you are not wearing protective eyewear. If this happens, the RXLALTM may have to be removed and replaced with a new intraocular lens to improve vision. This can lead to other complications from the additional surgery.
                </Paragraph>
                <Paragraph>
                    UV light can cause a reactivation of previous herpes virus infection in the eye, which is why it is important to tell your doctor about any previous eye infections or problems. The reactivation of herpes virus may require treatment with anti-viral medications to reduce or prevent scarring of the cornea, blurred vision, eye pain, extreme light sensitivity, permanent loss of vision, and possible need for corneal transplant. Corneal dryness and corneal abrasions from the contact lens used during the light treatments can also occur.
                </Paragraph>
                <Paragraph>LDD light treatment can also lead to a temporary or longer-term pink to red tinge to the vision or color vision deficiency. Since some medications and supplements can potentially increase your eye's sensitivity to UV light, it is important that you discuss your medications with your doctor.</Paragraph>
                <Paragraph>It is possible that the desired results of the surgery and/or light treatment may not be obtained or may not last. Since it is impossible to identify every complication that may occur as a result of any surgery, there may be risks that have not been described here.</Paragraph>
                <Paragraph>I have read and understand the above information. I understand the risks associated with this procedure and wish to proceed.</Paragraph>


                <div className="mb-4">
                    <InitialsField
                        FormData={SurgeryFormData}
                        Para="I have read and understand the above information. I understand the risks associated with this procedure and wish to proceed."
                        id="lal_agreed"
                        value={SurgeryFormData.lal_agreed}
                        onChange={(fieldId, fieldValue) =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                [fieldId]: fieldValue,
                            }))
                        }
                        isInvalid={invalidFields.includes("lal_agreed") && !SurgeryFormData.lal_agreed}
                        required={true}
                        disabled={isNext}
                    />
                </div>



                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <PatientSignatureImage
                        signature={SurgeryFormData['patient_signature']}
                        label="Parent/Guardian Signature"
                        signedDate={SurgeryFormData.patientSignedDate}
                    />
                    <PatientSignatureImage
                        signature={SurgeryFormData['witness_signature']}
                        label="Witness Signature"
                        signedDate={SurgeryFormData.witnessSignedDate}
                    />
                </div>




            </div>
            <div className="mb-2">
                <SegFooter />
            </div>
        </div>
    );
};

export default LALConsent;